import { LitElement, html, css } from 'lit';
import './nav-bar.js';

class AppShell extends LitElement {
  static properties = {
    currentPath: { type: String, attribute: 'current-path' },
  };

  static styles = css`
    :host { display: block; }
    .content {
      padding-bottom: 4rem; /* space for mobile nav */
    }
    @media (min-width: 768px) {
      .content { padding-bottom: 0; }
    }
  `;

  constructor() {
    super();
    this.currentPath = '/';
  }

  render() {
    return html`
      <nav-bar current-path=${this.currentPath}></nav-bar>
      <div class="content">
        <slot></slot>
      </div>
    `;
  }
}

customElements.define('app-shell', AppShell);
